<template>
	<div>
		<ParamResult ref="paramResult"></ParamResult>
		<div fillheight="lastHeight" scroll>
			<div
				class="
					last-order-record
					panel
					bgPanel
					pt2x
					cb
					pr2x
					pl2x
					pb2x
					mr205x
					ml205x
					borderbox
				"
			>
				<Loading ref="Loading"></Loading>
				<section class="fs12x lh15">
					<span>{{
						getLanguageStr("word1505", "最近一条指令记录")
					}}</span>
				</section>
				<no-result v-show="!lastOrderInfo"></no-result>
				<div class="result" v-if="lastOrderInfo">
					<section class="tableSys pt1x pl1x pr1x">
						<div class="pt05x pb05x w33pct pl1x pr1x">
							<span class="cSub"
								>{{
									getLanguageStr("word1501", "指令名称")
								}}：</span
							>{{ orderResult.orderName }}
						</div>
						<div class="pt05x pb05x w33pct pl1x pr1x">
							<span class="cSub"
								>{{
									getLanguageStr(
										"device_management69",
										"指令类型"
									)
								}}：</span
							>{{ orderResult.type }}
						</div>
						<div class="pt05x pb05x w33pct pl1x pr1x vaM_E">
							<span class="dpIB vaM_E cSub"
								>{{
									getLanguageStr("word1777", "指令状态")
								}}：</span
							>
							<span
								v-if="
									lastOrderInfo.status == 100 ||
										lastOrderInfo.status == 300
								"
								class="progressBar w30pct mr05x dpIB"
							>
								<div class="probody bgProgress posR">
									<div
										class="
											probody
											leftFill
											bgMain
											progressMove
											h100pct
											boxR-light
											dpIB
										"
									></div>
								</div>
							</span>
							<span
								class="dpIB vaM_E cPrimary"
								v-if="
									lastOrderInfo.status == 100 ||
										lastOrderInfo.status == 300
								"
							>
								{{ getLanguageStr("word1542", "发送中") }}
							</span>
							<span
								class="dpIB vaM_E cSuccess"
								v-if="lastOrderInfo.status == 666"
							>
								<div class="dpIB fWhite">
									<div class="icoSys dvStatus bgSuccess">
										<Icon
											name="yes"
											:type="'svg'"
											class="w100pct h100pct"
										/>
									</div>
								</div>
								<div class="dpIB">
									{{ getLanguageStr("word201", "已成功") }}
								</div>
							</span>
							<span
								class="dpIB vaM_E cWarning"
								v-if="lastOrderInfo.status == 500"
							>
								<div class="dpIB fWhite">
									<div class="icoSys dvStatus bgWarning">
										<Icon
											name="no"
											:type="'svg'"
											class="w100pct h100pct"
										/>
									</div>
								</div>
								<div class="dpIB">
									{{ getLanguageStr("word202", "失败") }}
								</div>
								<span class="pl2x cMain curP" @click="resend">{{
									getLanguageStr("cmd77", "重试")
								}}</span>
							</span>
						</div>
					</section>
					<section class="tableSys pt2x pl1x pr1x">
						<div
							class="pt05x pb05x w33pct pl1x pr1x"
							v-if="
								orderResult.values &&
									orderResult.values.length > 1
							"
						>
							<span class="cSub">{{ orderResult.name }}：</span
							><span
								@click="
									openResult(
										orderResult.values,
										lastOrderInfo
									)
								"
								class="curP cMain"
								>{{
									getLanguageStr("device403", "点击查看")
								}}</span
							>
						</div>
						<div
							v-else
							v-show="orderResult.value"
							class="pt05x pb05x w33pct pl1x pr1x"
						>
							<span class="cSub">{{ orderResult.name }}：</span
							>{{ orderResult.value }}
						</div>
						<div class="pt05x pb05x w33pct pl1x pr1x">
							<span class="cSub"
								>{{
									getLanguageStr("word57", "发送时间")
								}}：</span
							>{{
								timeFormat(
									lastOrderInfo.createTime / 1000,
									"system",
									"%Y/%m/%d %H:%M:%S UTC"
								)
							}}
						</div>
						<div
							class="pt05x pb05x w33pct pl1x pr1x"
							v-if="
								lastOrderInfo.status != 100 &&
									lastOrderInfo.status != 300
							"
						>
							<span class="cSub"
								>{{
									getLanguageStr("plant56", "反馈时间")
								}}：</span
							>{{
								timeFormat(
									lastOrderInfo.updateTime / 1000,
									"system",
									"%Y/%m/%d %H:%M:%S UTC"
								)
							}}
						</div>
					</section>
				</div>
			</div>
			<div
				class="
					panel
					bgPanel
					pt2x
					cb
					pr2x
					pl2x
					pb2x
					mt2x
					ml205x
					mr205x
					borderbox
					mt1x
				"
			>
				<section class="fs12x lh15">
					<span>{{ getLanguageStr("word1506", "选择指令") }}</span>
				</section>
				<section class="flexW aiC pt1x pl1x pr1x vaM_E">
					<div class="w10x cSub">
						{{ getLanguageStr("word1501", "指令名称") }}：
					</div>
					<div class="w33pct vaM_E vaM vaM_EE pr2x">
						<Select
							:name="'orderName'"
							class="w100pct"
							@Click="orderNameChange"
							:list="getConfigOptionI18nList"
							:keyMap="{ text: 'name', value: 'code' }"
							:search="{
								key: 'name',
								placeholder: getLanguageStr('app17', '搜索')
							}"
							ref="Select"
						></Select>
					</div>
					<div class="w15pct">
						<span v-if="chooseOrder" class="dpIB cSub"
							>{{
								getLanguageStr(
									"device_management69",
									"指令类型"
								)
							}}：</span
						>
						<span v-if="chooseOrder">{{
							chooseOrder.code | orderType
						}}</span>
					</div>
					<div :class="ipts.length > 1 ? 'w100pct' : 'flex100'">
						<OrderInput
							v-show="ipts.length"
							ref="orderInput"
						></OrderInput>
					</div>
				</section>
				<section class="tableSys pt1x pl1x pr1x mt3x">
					<div class="pt05x pb1x vaM_E taR">
						<div class="dpIB pr2x">
							<span class="cSub"
								>{{
									getLanguageStr("word1507", "超时时间")
								}}：</span
							>
							<InputText
								class="w7x dpIB ml05x mr05x"
								v-model="orderTimeout"
								:max-length="2"
								only="absInt"
								:verification="'notEmpty,~:1~10'"
								@Blur="inpBlur"
							></InputText>
							<span class="cSub">{{
								getLanguageStr("unit54", "分钟")
							}}</span>
							<Help
								:code="'orderControl'"
								:btnClose="false"
								class="vaM ml1x"
								ref="Help"
							></Help>
						</div>
						<button
							onclick="statistic('A69','A6903')"
							:class="{
								disable:
									lastOrderInfo.status == '100' ||
									!canClickSend ||
									lastOrderInfo.status == 300
							}"
							class="functionBtn"
							type="button"
							@click="sendOrder"
						>
							{{ getLanguageStr("plant109", "发送指令") }}
						</button>
					</div>
				</section>
			</div>
			<div ref="view"></div>
		</div>
	</div>
</template>

<script>
import * as lib from '@/util/lib';
import * as orderConfig from '@/util/deviceOrderConfig';
import {getLanguageStr} from '@/util/language';
import * as orderApi from '@/api/device/order';
import {getLanguage, getLanguageList} from '@/util/deviceOrderConfig.js';
import OrderInput from '@/view/device/device/part/OrderInput.vue';
import Help from '@/components/common/Help.vue';
import ParamResult from '@/view/device/device/part/ParamResult.vue';

export default {
	name: 'ParamControl',
	components: {OrderInput, Help, ParamResult},
	props: {
		device: {
			type: Object
		},
		deviceType: {
			type: String,
			default: undefined
		}
	},
	data () {
		return {
			lastOrderInfo: {},
			orderResult: {},
			orderInterval: null,
			orderNameList: [
				{
					code: '',
					codeGroup: '',
					name: ['word806', '请选择'],
					token: true
				}
			], // 产品（将全部加入数组头部）
			orderTimeout: 0, // 默认超时时间
			chooseOrder: null,
			ipts: [],
			orderMap: {}, // 存储指令列表的索引，以便实现动态改变指令内容的需求
			canClickSend: false,
			orderId: '',
			terminal: null,
			stage,
			// 手机端字段
			showOrderPop: false, // 指令pop 展示
			selectPopOrder: {}, // 指令pop中，选中的指令
			mobileTimeoutList: Array.from({length: 10}).map((v, k) => ({
				text: `${k + 1}${getLanguageStr('plant104', '分钟')}`,
				val: k + 1
			})),
			defaultIndex: 0
		};
	},
	methods: {
		getOrderName: orderConfig.getLanguage,
		getLanguage,
		getLanguageStr,
		timeFormat: lib.timeFormat,
		show (data) {
			this.$refs.Loading.show();
			this.chooseOrder = null;
			this.ipts = [];
			this.canClickSend = false;
			this.$refs.Select.reset(true);
			this.getListCode(data);
			this.lastOrder();
			// pc 页面逻辑
			this.terminal == 0 && this.$refs.Help.setPosition();
		},
		deviceUpdateClose () {
			if (this.orderInterval) clearInterval(this.orderInterval); // 清楚定时器。
		},
		async returnSingleList (data) {
			const that = this;
			// 进行特殊处理，例如1107
			let outData = [...data.single];
			outData.map((item, index) => {
				item.name = orderConfig.getOrderName(item.code, item.codeGroup);
				item.ipts = orderConfig.getIptConfig(item.code, item.codeGroup);
				return item;
			});
			if (
				data.optionExSingle &&
				deviceConfigOption.rule.optionEx[data.optionExSingle.group]
			) {
				$.each(data.optionExSingle.optionList, (index, value) => {
					let cmd = lib.objTool(outData, 'findByKey', [
						'code',
						value.key
					])[1];
					if (cmd) {
						// 没有授权该特殊规则的指令不处理
						if (value.key.substr(0, 2) == 'r_') {
							cmd.optionEx = value;
						} else {
							cmd.ipts[0].optionEx = value;
							cmd.ipts[0].select = [
								{
									value: '',
									text: ['word806', '请选择'],
									token: true
								}
							].concat(
								lib.objTool(
									deviceConfigOption.rule.optionEx[
										data.optionExSingle.group
									][value.dataKey][value.target],
									'returnSelectData',
									{
										fromTextKey: 'targetValue',
										fromValueKey: 'strValue',
										toTextKey: 'text',
										toValueKey: 'value'
									}
								)
							); // 拼出可用的下拉数据
						}
					}
				});
			}
			that.orderNameList = [
				{
					code: '',
					codeGroup: '',
					name: ['word806', '请选择'],
					token: true
				}
			].concat(outData);
			$.each(that.orderNameList, (index, order) => {
				if (order.code) {
					that.orderMap[order.code] = order; // 存储索引
				}
			});
		},
		getListCode (data) {
			// 合并指令数据
			if (data && data.single && data.single.length) {
				this.returnSingleList(data);
			} else {
				orderApi
					.apiGetAvailableOrder(
						this.device.productId,
						this.device.deviceId
					)
					.then(
						res => {
							this.returnSingleList(res);
						},
						error => {
							return false;
						}
					);
			}
		},
		// 获取最后一条
		async lastOrder (isPolling) {
			try {
				let result;
				if (!isPolling) {
					result = await orderApi.orderActionLast({
						deviceId: this.device.deviceId,
						// deviceType: this.deviceType,
						orderType: 1, // 指令类型(1.读取 2.设置)
						operationType: 12,
						language: stage.languageId
					});
					this.orderId = result.orderId;
				} else {
					result = await orderApi.orderActionById(this.orderId);
				}
				result = _.cloneDeep(result);
				this.lastOrderInfo = result;
				if (result) {
					this.orderResult = orderConfig.analyFunction(result) || {};
					if (this.orderInterval) clearInterval(this.orderInterval);
					if (result.status == 100 || result.status == 300) {
						// 指令发送中，禁止点击
						this.canClickSend = false;
						this.orderInterval = setInterval(() => {
							// 失败情况继续查询状态
							this.lastOrder(true);
						}, 2000);
					} else {
						this.canClickSend = true;
						let _code = this.lastOrderInfo.groupCode.split(',')[0];
						let _name = this.lastOrderInfo.groupCode.split(',')[1];
						let iUnlock =
							deviceConfigOption.map[_code][_name].unlock;
						if (this.lastOrderInfo.status == 666 && iUnlock) {
							// 仅成功且有动态规则的指令进行操作
							let targetOrder = this.orderMap[iUnlock.targetCode]
								.ipts[iUnlock.index];
							targetOrder.lock = false;
							// if(this.lastOrderInfo.analysisResult){//根据动作类型操作目标指令的属性
							switch (iUnlock.action) {
							case 'areaMax':
								targetOrder.input.inputTips = [
									`word905+:0~${this.lastOrderInfo.analysisResult}`,
									`输入规则:0~${this.lastOrderInfo.analysisResult}`
								];

								targetOrder.input.rule.areas[0][1] = Number(
									this.lastOrderInfo.analysisResult
								);
								targetOrder.input.placeholder = targetOrder.input.rule.areas[0].join(
									'~'
								);
								break;
							}
							// }
						}
					}
				} else {
					this.canClickSend = true;
				}
				this.$refs.Loading.hide();
				return result;
			} catch (error) {
				trace(error);
				this.$refs.Loading.hide();
				return false;
			}
		},
		orderNameChange (index) {
			// 切换指令
			if (this.orderNameList[index].code) {
				this.chooseOrder = this.orderNameList[index];
				this.ipts = this.orderNameList[index].ipts || [];
				if (index == 0) this.canClickSend = false;
				else this.canClickSend = true;
				this.$refs.orderInput.init(this.ipts);
			}
		},
		paramCheck () {
			let cr = true;
			if (this.chooseOrder == null || this.chooseOrder.code == '') {
				cr = false;
				this.$notify(getLanguageStr('manage278', '请选择指令'), {
					className: 'mTips'
				});
			}
			if (cr && Number(this.orderTimeout) == 0) {
				this.$notify(getLanguageStr('phrase847', '请输入超时时间'));
				cr = false;
			}
			return cr;
		},
		openResult (data, lastOrderInfo) {
			const list = data.map(item => ({
				name: getLanguage(item.configInfo.subName[0], '子参数名'),
				value: item.value
			}));
			const title =
				lastOrderInfo.operationType === 2
					? getLanguageStr('plant_detail141', '输入项')
					: getLanguageStr('device235', '读取结果');
			this.$refs.paramResult.show({
				list,
				title,
				terminal: this.terminal
			});
		},
		openResultM (data, lastOrderInfo) {
			this.resultMList = data.map(item => ({
				name: getLanguage(item.configInfo.subName[0], '子参数名'),
				value: item.value
			}));
			this.resultMTitle =
				lastOrderInfo.operationType === 2
					? getLanguageStr('plant_detail141', '输入项')
					: getLanguageStr('device235', '读取结果');
			this.resultDialog = true;
		},
		async sendOrder () {
			if (this.orderTimeout < 1 || this.orderTimeout > 10) {
				return false;
			}
			if (this.paramCheck()) {
				let iptValue = this.$refs.orderInput.getOrderInputValue();
				if (iptValue) {
					let extendWeb = {
						inputParam: []
					};
					if (this.chooseOrder.orderType === 1) {
						extendWeb.inputParam.push({
							optionEx: this.chooseOrder.optionEx
						});
					} else if (this.chooseOrder.orderType == 2) {
						iptValue.map(ipt => {
							let out = ipt.valTurn
								? ipt.valTurn(ipt)
								: ipt.value;
							if (ipt.type == 'time') {
								// 时间数据的处理
								out = lib.timeFormat(
									ipt.value,
									'system',
									'%Y%m%d%H%M%S'
								);
								ipt.value = lib.timeFormat(
									ipt.value,
									'system',
									'%Y/%m/%d %H:%M:%S'
								);
							}
							if (ipt.type == 'hm') {
								ipt.value = ipt.valueH + ':' + ipt.valueM;
								out = ipt.valueH + ipt.valueM;
							}
							// 根据区间获取真实取值
							if (
								ipt.type === 'input' &&
								this.getIn(ipt, ['input', 'rule', 'outValue'])
							) {
								const outValue = ipt.input.rule.outValue;
								let ok = false;
								for (let i = 0; i < outValue.length; i++) {
									if (outValue[i].type === 'range') {
										const condition = outValue[i].condition;
										let less = false;
										if (condition[0].value) {
											less = condition[0].include
												? condition[0].value <= out
												: condition[0].value < out;
										} else {
											less = true;
										}
										let more = false;
										if (condition[1].value) {
											more = condition[1].include
												? condition[1].value >= out
												: condition[1].value > out;
										} else {
											less = true;
										}
										ok = less && more;
										if (ok) {
											out = Number(outValue[i].value);
											break;
										}
									}
								}
							}
							let inputItem = {
								value: out,
								ext: ipt.ext ? ipt.ext : '',
								oValue: ipt.value,
								unit: ipt.unit,
								optionEx: ipt.optionEx
							};
							ipt.sk && (inputItem.sk = ipt.sk);
							extendWeb.inputParam.push(inputItem);
						});
					}
					let req = {
						deviceId: this.device.deviceId,
						code: this.chooseOrder.code,
						codeGroup: this.chooseOrder.codeGroup,
						deviceSn: this.device.deviceSn,
						// 'deviceType': this.device.deviceType,
						gatewayId: this.device.parDeviceId,
						gatewaySn: this.device.parDeviceSn,
						operationType: this.chooseOrder.orderType, // 自定义
						orderTimeout: this.orderTimeout * 60, // 指令超时时间 单位秒
						product: this.device.productId,
						// 'sensor': this.device.sensor,
						extendWeb: JSON.stringify(extendWeb)
					};
					// return;
					try {
						this.canClickSend = false;
						await orderApi.orderActionControlSend(req);
						this.canClickSend = false;
						if (this.lastOrderInfo) {
							this.lastOrderInfo.status = '100';
						}
						this.$refs.Loading.hide();
						setTimeout(() => {
							this.lastOrder();
						}, 2000);
					} catch (error) {
						this.canClickSend = false;
						this.$refs.Loading.hide();
					}
				}
			}
		},
		async resend () {
			try {
				await orderApi.orderActionControlResend(this.orderId, {
					timeoutSeconds: 60
				});
				this.canClickSend = false;
				if (this.lastOrderInfo) this.lastOrderInfo.status = '100';
				this.$refs.Loading.hide();
				setTimeout(() => {
					this.lastOrder();
				}, 2000);
			} catch (e) {
				return e;
			}
		},

		// 移动端事件处理
		async getMobileData (data) {
			await this.getListCode(data);
			await this.lastOrder();
		},
		// 打开指令pop弹窗
		selectOrderPopup () {
			this.showOrderPop = true;
		},
		// 确定指令pop弹窗
		confirmOrderPop () {
			this.showOrderPop = false;
			this.selectPopOrder = {
				...this.selectPopOrder,
				...this.getConfigOptionI18nList[this.selectPopOrder.popIndex]
			};
		},
		// 取消指令pop弹窗
		cancelOrderPop () {
			this.showOrderPop = false;
			this.chooseOrder = null;
			this.selectPopOrder = {};
		},
		// 移动端选择指令
		orderMobileNameChange (index) {
			if (this.orderNameList[index].code) {
				this.chooseOrder = this.orderNameList[index];
				this.ipts = this.orderNameList[index].ipts || [];
				this.$refs.orderInput.init(this.ipts);
				this.selectPopOrder = {
					...this.selectPopOrder,
					code: this.getConfigOptionI18nList[index].code,
					popIndex: index
				};
			}
		},
		selectMobileTime (item) {
			this.orderTimeout = item.val;
			this.defaultIndex = this.mobileTimeoutList.findIndex(
				m => m.val == this.orderTimeout
			);
		},
		// 移动端tips
		showHelpTips () {
			this.$notify(
				getLanguageStr(
					'phrase628',
					'超时仍未收到指令反馈将默认发送失败，可再次发送'
				),
				{
					title: getLanguageStr('task22', '超时时间'),
					className: 'timeMTips'
				}
			);
		},
		inpBlur () {
			if (stage.browser.ios) {
				$('html,body').animate(
					{scrollTop: $('body').offset().top},
					0
				);
			}
		}
	},
	computed: {
		getConfigOptionI18nList: function () {
			return orderConfig.getLanguageList(this.orderNameList);
		}
	},
	mounted () {
		lib.fillHeight();
		setTimeout(() => {
			this.terminal == 0 && this.$refs.Help.setPosition();
			// this.orderTimeout = this.terminal == 1 ? 1 : 10;
			// 获取默认超时时间
			let requestObj = {
				module: 101 // 单条指令
			};
			if (this.device.deviceId) {
				orderApi.apiGetCustomTimeoutList(this.device.deviceId, requestObj).then((res) => {
					if (res) {
						this.orderTimeout = res / 60 || 3;
					}
				});
			}
		}, 1000);
	},
	destroyed () {
		this.deviceUpdateClose();
	},
	created () {
		this.terminal = stage.browser.mobile ? 1 : 0;
	},
	filters: {
		orderType (data) {
			if (!data.length) return;
			const strList = data.split('-');
			return strList[strList.length - 1].includes('s_')
				? getLanguageStr('cmd16', ['设置'])
				: getLanguageStr('word632', ['读取']);
		}
	}
};
</script>

<style lang="scss" scoped>
.chat-content {
	display: flex;
	flex-direction: column-reverse;
	-moz-box-orient: vertical;
	-webkit-box-orient: vertical;
	-webkit-box-direction: reverse;
	-moz-box-direction: reverse;
	height: 100%;
	overflow-y: auto;
}
.chat-content .resend {
	vertical-align: middle;
}

.fsCunstom {
	font-size: 0.6em !important;
}
.flexBox {
	display: flex;
	flex-direction: row;
	align-items: center;
}
.timecust {
	width: 50% !important;
}
.elapsedTime {
	position: absolute;
	top: 100%;
	left: 0;
	width: 100%;
}
.orderList {
	scrollbar-width: none; /* firefox */
	-ms-overflow-style: none; /* IE 10+ */
	overflow-x: hidden;
	overflow-y: auto;
	&::-webkit-scrollbar {
		display: none; /* Chrome Safari */
	}
}

.selectBox {
	padding-right: 3.2vmin;
	padding-left: 3.2vmin;
	background-color: #f3f3f6;
}
.moreB {
	position: absolute;
	top: 50%;
	right: 3.2vmin;
	transform: translate(0, -50%);
}
.s-more {
	color: rgb(150, 151, 153);
	transform: rotate(90deg);
}
.popupStyle {
	max-height: 76%;
	// overflow: hidden;
	border-radius: 3.2vmin 3.2vmin 0 0;
}
.popupHeader {
	position: fixed;
	// top: 0;
	left: 0;
	z-index: 10;
	border-radius: 3.2vmin 3.2vmin 0 0;
}

.mobile {
	.border:after {
		position: absolute;
		top: 0;
		left: 0;
		box-sizing: border-box;
		width: 200%;
		height: 200%;
		content: "";
		border-bottom: 1px solid #e6e9f0;
		-webkit-transform: scale(0.5);
		transform: scale(0.5);
		-webkit-transform-origin: top left;
	}
	.topspace {
		margin-top: 2.66vmin;
	}
	.h405x {
		height: 9.6vmin;
	}
}
.progressMove {
	left: 0;
	top: 0;
	position: absolute;
	-webkit-animation: promove 5s infinite;
	-moz-animation: promove 5s infinite;
	animation: promove 5s;
	-webkit-animation-iteration-count: infinite;
	-moz-animation-iteration-count: infinite;
	animation-iteration-count: infinite;
	-webkit-animation-fill-mode: forwards;
	-moz-animation-fill-mode: forwards;
	animation-fill-mode: forwards;
}
@keyframes promove {
	0% {
		width: 0px;
	}
	50% {
		width: 50%;
	}
	100% {
		width: 100%;
	}
}
@-webkit-keyframes promove {
	0% {
		width: 0px;
	}
	50% {
		width: 50%;
	}
	100% {
		width: 100%;
	}
}
</style>
<style lang="scss"></style>



// WEBPACK FOOTER //
// src/view/device/device/part/ParamControl.vue